export const BUTTON_TYPE_PRIMARY = 'primary';
export const BUTTON_TYPE_SECONDARY = 'secondary';
export const BUTTON_TYPE_TERTIARY = 'tertiary';
export const BUTTON_TYPE_TERTIARY_OUTLINED = 'tertiary-outlined';
export const BUTTON_TYPE_DANGER = 'danger';
export const BUTTON_TYPE_DANGER_OUTLINE = 'danger-outline';
export const BUTTON_TYPE_LINK = 'link';
export const BUTTON_TYPE_LINK_WITH_ARROW = 'link-with-arrow';

export const BUTTON_TYPES = [
    BUTTON_TYPE_PRIMARY,
    BUTTON_TYPE_SECONDARY,
    BUTTON_TYPE_TERTIARY,
    BUTTON_TYPE_TERTIARY_OUTLINED,
    BUTTON_TYPE_DANGER,
    BUTTON_TYPE_DANGER_OUTLINE,
    BUTTON_TYPE_LINK,
    BUTTON_TYPE_LINK_WITH_ARROW,
] as const;

export const BUTTON_SIZE_SMALL = 'small';

export const BUTTON_SIZES = [BUTTON_SIZE_SMALL];
